export enum NewsModule {
  DownloadCenter = 1,
  UpgradeWebsite = 2,
  UpgradeDocumentation = 3,
  UpgradeDevPortal = 4,
  UpgradeDownloadCenter = 5,
  UpgradeUserCenter = 6,
}
